<script>
const PropsType = () => {
  return [Number, String, Object];
};

export default {
  name: 'AppTableCell',
  props: {
    value: {
      type: new PropsType(),
      default: '',
    },
  },
  render: function(h) {
    return h('div', {
    }, [this.value]);
  },
};
</script>
